(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-scent-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById("ar-quiz"); if(!root) return;
  var recs={},cfg={};
  try{recs=JSON.parse(root.querySelector("[data-ar-quiz-recs]").textContent);}catch(e){}
  try{cfg=JSON.parse(root.querySelector("[data-ar-quiz-config]").textContent);}catch(e){}
  var $=function(s){return root.querySelector(s);};
  var screens={intro:$('[data-screen="intro"]'),questions:$('[data-screen="questions"]'),results:$('[data-screen="results"]')};
  function show(n){for(var k in screens)screens[k].hidden=(k!==n);window.scrollTo({top:root.getBoundingClientRect().top+window.pageYOffset-20,behavior:"smooth"});}

  var I={
    men:'<svg viewBox="0 0 24 24"><circle cx="10" cy="14" r="6"/><path d="M15 9l5-5m0 0h-4m4 0v4"/></svg>',
    women:'<svg viewBox="0 0 24 24"><circle cx="12" cy="9" r="6"/><path d="M12 15v6m-3-3h6"/></svg>',
    unisex:'<svg viewBox="0 0 24 24"><path d="M12 2v6m0 0a4 4 0 100 8 4 4 0 000-8zm0 12v6m-3-3h6"/><path d="M16 5l3-3m0 0h-3m3 0v3"/></svg>',
    fresh:'<svg viewBox="0 0 24 24"><path d="M12 3s6 6 6 11a6 6 0 01-12 0c0-5 6-11 6-11z"/></svg>',
    warm:'<svg viewBox="0 0 24 24"><path d="M12 3c1 3-2 4-2 7a4 4 0 008 0c0-1-1-3-2-4 0 2-1 3-2 3 0-3-1-5 0-6z"/><path d="M8 14a4 4 0 008 0"/></svg>',
    bold:'<svg viewBox="0 0 24 24"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"/></svg>',
    woody:'<svg viewBox="0 0 24 24"><path d="M12 21v-7m0 0l-4-4m4 4l4-4m-4-2V3"/><path d="M12 11l-3-3m3 3l3-3"/></svg>',
    floral:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="2.5"/><path d="M12 9.5c0-3 2-5 0-7-2 2 0 4 0 7zm0 5c0 3-2 5 0 7 2-2 0-4 0-7zm-2.5-2.5c-3 0-5-2-7 0 2 2 4 0 7 0zm5 0c3 0 5-2 7 0-2 2-4 0-7 0z"/></svg>',
    everyday:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3M5 5l2 2m10 10l2 2M5 19l2-2m10-10l2-2"/></svg>',
    date:'<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-9-9a5 5 0 019-2 5 5 0 019 2c-2 4.5-9 9-9 9z"/></svg>',
    office:'<svg viewBox="0 0 24 24"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>',
    special:'<svg viewBox="0 0 24 24"><path d="M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z"/></svg>',
    b1:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 8v8m-2-6h3a2 2 0 010 4h-3"/></svg>',
    b2:'<svg viewBox="0 0 24 24"><circle cx="9" cy="12" r="6"/><circle cx="16" cy="12" r="6"/></svg>',
    b3:'<svg viewBox="0 0 24 24"><circle cx="7" cy="12" r="5"/><circle cx="12" cy="12" r="5"/><circle cx="17" cy="12" r="5"/></svg>',
    bany:'<svg viewBox="0 0 24 24"><path d="M3 8l3-4h12l3 4-9 12z"/><path d="M3 8h18M9 4l3 16 3-16"/></svg>',
    try:'<svg viewBox="0 0 24 24"><path d="M9 2h6M10 2v5l-3 9a3 3 0 003 4h4a3 3 0 003-4l-3-9V2"/><path d="M7.5 14h9"/></svg>',
    bottle:'<svg viewBox="0 0 24 24"><path d="M9 2h6v3l1 2v13a2 2 0 01-2 2H10a2 2 0 01-2-2V7l1-2z"/><path d="M8 11h8"/></svg>',
    sun:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.5"/><path d="M12 1v3M12 20v3M1 12h3M20 12h3M4 4l2 2M18 18l2 2M4 20l2-2M18 6l2-2"/></svg>',
    snow:'<svg viewBox="0 0 24 24"><path d="M12 2v20M2 12h20M5 5l14 14M19 5 5 19"/></svg>',
    allyear:'<svg viewBox="0 0 24 24"><path d="M21 12a9 9 0 11-2.64-6.36M21 4v4h-4"/></svg>',
    str1:'<svg viewBox="0 0 24 24"><rect x="5" y="13" width="3.5" height="6" rx="1"/></svg>',
    str2:'<svg viewBox="0 0 24 24"><rect x="4" y="13" width="3.5" height="6" rx="1"/><rect x="10.5" y="9" width="3.5" height="10" rx="1"/></svg>',
    str3:'<svg viewBox="0 0 24 24"><rect x="3" y="13" width="3.5" height="6" rx="1"/><rect x="10" y="9" width="3.5" height="10" rx="1"/><rect x="17" y="5" width="3.5" height="14" rx="1"/></svg>'
  };

  var NOTE_OPTS=[
    {v:"citrus",l:"Citrus"},{v:"aquatic",l:"Fresh / Aquatic"},{v:"green",l:"Green / Herbal"},
    {v:"floral",l:"Floral"},{v:"fruity",l:"Fruity"},{v:"sweet",l:"Sweet / Gourmand"},
    {v:"vanilla",l:"Vanilla"},{v:"amber",l:"Amber"},{v:"woody",l:"Woody"},
    {v:"leather",l:"Leather / Smoke"},{v:"spicy",l:"Spicy"},{v:"oud",l:"Oud"},{v:"musk",l:"Musk"}
  ];

  var QUESTIONS=[
    {key:"gender",q:"Who is this for?",opts:[
      {v:"men",l:"Men",i:"men",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-men.webp?v=1782268703"},
      {v:"women",l:"Women",i:"women",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-women.webp?v=1782268705"},
      {v:"unisex",l:"Surprise me",s:"Unisex",i:"unisex",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-unisex.webp?v=1782268707"}]},
    {key:"vibe",q:"What vibe are you after?",opts:[
      {v:"fresh",l:"Fresh & clean",s:"Citrus, aquatic, green",i:"fresh",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-vibe-fresh.webp?v=1782267402"},
      {v:"warm",l:"Warm & sweet",s:"Amber, vanilla, gourmand",i:"warm",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-vibe-warm.webp?v=1782267404"},
      {v:"bold",l:"Bold & spicy",s:"Spice, leather, oud",i:"bold",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-vibe-bold.webp?v=1782267406"},
      {v:"woody",l:"Woody & refined",s:"Wood, smoke, earth",i:"woody",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-vibe-woody.webp?v=1782267408"},
      {v:"floral",l:"Floral & fruity",s:"Petals, fruit, musk",i:"floral",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-vibe-floral.webp?v=1782267410"}]},
    {key:"occasion",q:"When will you wear it most?",opts:[
      {v:"everyday",l:"Everyday",i:"everyday",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-everyday.webp?v=1782268709"},
      {v:"date",l:"Date night",i:"date",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-date.webp?v=1782268712"},
      {v:"office",l:"Work / office",i:"office",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-office.webp?v=1782268714"},
      {v:"special",l:"Special occasions",i:"special",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-special.webp?v=1782268716"}]},
    {key:"season",q:"What weather will you wear it in?",opts:[
      {v:"hot",l:"Warm weather",s:"Spring & summer",i:"sun",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-season-hot.webp?v=1782512200"},
      {v:"cold",l:"Cool weather",s:"Fall & winter",i:"snow",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-season-cold.webp?v=1782512203"},
      {v:"any",l:"All year round",s:"No preference",i:"allyear",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-season-any.webp?v=1782512206"}]},
    {key:"strength",q:"How noticeable do you want to be?",opts:[
      {v:"subtle",l:"Subtle",s:"Close to the skin",i:"str1"},
      {v:"balanced",l:"Balanced",s:"Noticeable, not loud",i:"str2"},
      {v:"bold",l:"Bold",s:"Fills the room",i:"str3"}]},
    {key:"notesLove",q:"Any notes you love?",sub:"Tap all that appeal — or skip.",multi:true,optional:true,opts:NOTE_OPTS},
    {key:"notesHate",q:"Any notes you can't stand?",sub:"We'll steer your matches away from these — or skip.",multi:true,optional:true,opts:NOTE_OPTS},
    {key:"budget",q:"What's your budget?",opts:[
      {v:"under_50",l:"Under $50",s:"Smart picks",i:"b1",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-under_50.webp?v=1782268718"},
      {v:"50_100",l:"$50 – $100",s:"Sweet spot",i:"b2",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-50_100.webp?v=1782268720"},
      {v:"100_200",l:"$100 – $200",s:"Premium",i:"b3",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-100_200.webp?v=1782268722"},
      {v:"any",l:"No limit",s:"Show me the best",i:"bany",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-any.webp?v=1782268725"}]},
    {key:"commit",q:"How do you like to buy?",opts:[
      {v:"try",l:"Try it first",s:"Start with a decant",i:"try",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-try.webp?v=1782268727"},
      {v:"bottle",l:"Go for the bottle",s:"I know what I like",i:"bottle",img:"https://cdn.shopify.com/s/files/1/0671/1876/0051/files/ar-quiz-opt-bottle.webp?v=1782268729"}]}
  ];
  var BUDGET={under_50:[0,50],"50_100":[50,100],"100_200":[100,200],any:[0,1e9]};
  var answers={},step=0;

  function renderStep(){
    var Q=QUESTIONS[step];
    var html='<h2 class="ar-quiz__q-title">'+Q.q+'</h2>';
    if(Q.sub) html+='<p class="ar-quiz__q-sub">'+Q.sub+'</p>';
    if(Q.multi){
      html+='<div class="ar-quiz__chips">';
      Q.opts.forEach(function(o){ html+='<button type="button" class="ar-quiz__chip" data-val="'+o.v+'">'+o.l+'</button>'; });
      html+='</div><button class="ar-quiz__btn ar-quiz__btn--gold ar-quiz__continue" data-continue>Continue &rarr;</button>';
    } else {
      html+='<div class="ar-quiz__options">';
      Q.opts.forEach(function(o){
        if(o.img){
          html+='<button class="ar-quiz__opt ar-quiz__opt--photo" data-val="'+o.v+'" style="background-image:url('+o.img+')">'+
            '<span class="ar-quiz__opt-scrim"></span>'+
            '<span class="ar-quiz__opt-cap"><span class="ar-quiz__opt-l">'+o.l+'</span>'+(o.s?'<span class="ar-quiz__opt-s">'+o.s+'</span>':'')+'</span></button>';
        } else {
          html+='<button class="ar-quiz__opt" data-val="'+o.v+'"><span class="ar-quiz__opt-ico">'+(I[o.i]||"")+'</span>'+
            '<span class="ar-quiz__opt-l">'+o.l+'</span>'+(o.s?'<span class="ar-quiz__opt-s">'+o.s+'</span>':'')+'</button>';
        }
      });
      html+='</div>';
    }
    $('[data-qwrap]').innerHTML=html;
    $('[data-progress]').style.width=(step/QUESTIONS.length*100)+"%";
    $('[data-back]').hidden=(step===0);
    if(Q.multi){
      if(!Array.isArray(answers[Q.key]))answers[Q.key]=[];
      var sel=answers[Q.key],cont=$('[data-continue]');
      function syncCont(){cont.textContent=(sel.length?"Continue":(Q.optional?"Skip":"Continue"))+" →";}
      Array.prototype.forEach.call($('[data-qwrap]').querySelectorAll('.ar-quiz__chip'),function(c){
        if(sel.indexOf(c.getAttribute("data-val"))>=0)c.classList.add("is-on");
        c.addEventListener("click",function(){
          var val=c.getAttribute("data-val"),idx=sel.indexOf(val);
          if(idx>=0){sel.splice(idx,1);c.classList.remove("is-on");}else{sel.push(val);c.classList.add("is-on");}
          syncCont();
        });
      });
      syncCont();
      cont.addEventListener("click",function(){next();});
    } else {
      Array.prototype.forEach.call($('[data-qwrap]').querySelectorAll('.ar-quiz__opt'),function(b){
        b.addEventListener("click",function(){answers[Q.key]=b.getAttribute("data-val");next();});
      });
    }
  }
  function next(){ if(step<QUESTIONS.length-1){step++;renderStep();} else renderResults(); }
  $('[data-back]').addEventListener("click",function(){if(step>0){step--;renderStep();}});
  $('[data-start]').addEventListener("click",function(){step=0;answers={};show("questions");renderStep();});

  var VIBE_LABEL={fresh:"Fresh & Clean",warm:"Warm & Sweet",bold:"Bold & Spicy",woody:"Woody & Refined",floral:"Floral & Fruity"};
  var GENDER_LABEL={men:"men",women:"women",unisex:"unisex wear"};
  function money(n){try{return (n).toLocaleString("en-US",{style:"currency",currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||"USD"});}catch(e){return "$"+n;}}

  // ---- Weighted scoring matcher ----------------------------------------------
  // Each rec carries family + accords + price. We derive vibe/occasion/season/
  // strength affinity from those, so every answer actually moves the ranking.
  var ACCORD={
    citrus:["citrus","bergamot","lemon","grapefruit","mandarin","orange","lime","neroli","petitgrain"],
    aquatic:["aquatic","marine","fresh","sea","water","ozonic","calone","aldehyd","salt"],
    green:["green","herb","grass","galban","basil","mint","sage","lavender","fougere","aromatic"],
    floral:["floral","flower","rose","jasmine","iris","violet","tuberose","ylang","blossom","lily","muguet","osmanthus"],
    fruity:["fruit","apple","pineapple","peach","plum","berry","currant","melon","lychee","raspberry"],
    sweet:["sweet","gourmand","caramel","honey","chocolate","sugar","cotton","praline","toffee"],
    vanilla:["vanilla","tonka"],
    amber:["amber","ambergris","ambrox","ambrar","resin","labdanum","benzoin"],
    woody:["wood","cedar","sandalwood","vetiver","patchouli","oakmoss","cypress","guaiac"],
    leather:["leather","smoke","smoky","birch","tobacco","incense","tar","suede"],
    spicy:["spic","cinnamon","pepper","cardamom","clove","saffron","ginger","nutmeg"],
    oud:["oud","agarwood","oudh"],
    musk:["musk","powder","powdery","skin","clean"]
  };
  function accStr(p){return ((p.family||"")+" "+((p.accords||[]).join(" "))).toLowerCase();}
  function hasAccord(p,key){var s=accStr(p),syn=ACCORD[key]||[key];for(var i=0;i<syn.length;i++){if(s.indexOf(syn[i])>=0)return true;}return false;}
  function countAccord(p,keys){var c=0;for(var i=0;i<keys.length;i++){if(hasAccord(p,keys[i]))c++;}return c;}
  function anyAccord(p,keys){for(var i=0;i<keys.length;i++){if(hasAccord(p,keys[i]))return true;}return false;}
  var VIBE_ACC={fresh:["citrus","aquatic","green"],warm:["sweet","vanilla","amber"],bold:["spicy","leather","oud"],woody:["woody","leather"],floral:["floral","fruity","musk"]};
  var OCC_ACC={everyday:["citrus","aquatic","woody","musk","green"],date:["sweet","amber","oud","spicy","vanilla","leather"],office:["citrus","aquatic","green","woody","musk"],special:["oud","amber","leather","spicy","woody"]};
  var HOT=["citrus","aquatic","green","fruity"],COLD=["sweet","vanilla","amber","oud","leather","spicy","woody"];
  var STRONG=["sweet","vanilla","amber","oud","leather","spicy"],SOFT=["citrus","aquatic","green","musk"];
  var NOTE_LABEL={citrus:"citrus",aquatic:"fresh",green:"green",floral:"floral",fruity:"fruity",sweet:"sweet",vanilla:"vanilla",amber:"amber",woody:"woody",leather:"leather",spicy:"spice",oud:"oud",musk:"musk"};
  function strengthOf(p){var s=countAccord(p,STRONG),w=countAccord(p,SOFT);if(s>w)return 3;if(w>s)return 1;return 2;}
  function poolFor(g){
    var out=[],seen={},groups=(g&&g!=="unisex")?[g,"unisex"]:["unisex","men","women"];
    groups.forEach(function(gg){var byV=recs[gg]||{};for(var v in byV){(byV[v]||[]).forEach(function(p){var id=p.variantId||p.handle;if(id&&!seen[id]){seen[id]=1;out.push(p);}});}});
    return out;
  }
  function scoreMatches(a){
    var g=a.gender||"unisex",v=a.vibe||"fresh",occ=a.occasion,season=a.season||"any",
        strength=a.strength||"balanced",love=a.notesLove||[],hate=a.notesHate||[],
        budget=a.budget||"any",rng=BUDGET[budget]||BUDGET.any,
        desS={subtle:1,balanced:2,bold:3}[strength]||2,pool=poolFor(g);
    pool.forEach(function(p){
      var sc=0,reasons=[];
      if(anyAccord(p,VIBE_ACC[v]||[])){sc+=40;reasons.push("Matches your "+(VIBE_LABEL[v]||"")+" vibe");}
      if(occ&&anyAccord(p,OCC_ACC[occ]||[]))sc+=12;
      var hot=countAccord(p,HOT),cold=countAccord(p,COLD);
      if(season==="hot"){if(hot>cold){sc+=16;reasons.push("Made for warm weather");}else if(hot===cold)sc+=8;}
      else if(season==="cold"){if(cold>hot){sc+=16;reasons.push("Made for cool weather");}else if(cold===hot)sc+=8;}
      else sc+=8;
      var st=strengthOf(p);sc+=(2-Math.abs(st-desS))*8;
      if(st===desS)reasons.push(desS===3?"Bold projection":desS===1?"Subtle, skin-close":"Balanced projection");
      if(love.length){var lk=[];love.forEach(function(k){if(hasAccord(p,k))lk.push(NOTE_LABEL[k]||k);});if(lk.length){sc+=lk.length*14;reasons.push("Has the "+lk.slice(0,2).join(" & ")+" you love");}}
      var inB=p.price>=rng[0]&&p.price<=rng[1];
      if(inB){sc+=10;if(budget!=="any")reasons.push("Within your budget");}
      else{var mid=(rng[0]+Math.min(rng[1],600))/2;sc-=Math.min(22,Math.abs(p.price-mid)/14);}
      var hated=false;if(hate.length)hate.forEach(function(k){if(hasAccord(p,k))hated=true;});
      p._score=sc;p._inBudget=inB;p._hated=hated;p._reasons=reasons.slice(0,3);
    });
    var ok=pool.filter(function(p){return !p._hated;});
    var use=(ok.length>=3?ok:pool.slice());
    use.sort(function(x,y){return y._score-x._score;});
    var items=use.slice(0,4);
    var exact=items.length>0&&items.every(function(p){return p._inBudget&&!p._hated;});
    return {items:items,exact:exact};
  }

  function addToCart(btn,vid){
    if(!vid)return;
    btn.disabled=true; var orig=btn.innerHTML; btn.textContent="Adding…";
    var drawer=document.querySelector("cart-drawer");
    var secId=null; if(drawer){var w=drawer.closest('[id^="shopify-section-"]'); if(w)secId=w.id.replace("shopify-section-","");}
    var body={items:[{id:vid,quantity:1}]};
    if(secId){ body.sections=[secId]; body.sections_url=window.location.pathname; }
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
      .then(function(r){return r.ok?r.json():Promise.reject();})
      .then(function(addRes){
        btn.innerHTML="Added ✓";
        return fetch("/cart.js").then(function(r){return r.json();}).then(function(cart){
          if(secId && addRes.sections) cart.sections=addRes.sections;
          // Prestige cart-drawer re-renders + force-opens on this event
          document.dispatchEvent(new CustomEvent("cart:change",{detail:{cart:cart,baseEvent:"variant:add",onSuccessDo:"force_open_drawer"}}));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          // fallback: if the drawer didn't open (e.g. no drawer on page), surface a View-bag link
          setTimeout(function(){ var vb=btn.parentNode.querySelector("[data-viewbag]"); if(vb && (!drawer || !drawer.hasAttribute("open"))) vb.hidden=false; },450);
        });
      })
      .catch(function(){ btn.disabled=false; btn.innerHTML=orig; var m=btn.parentNode.querySelector("[data-adderr]"); if(m)m.hidden=false; });
  }

  function renderResults(){
    $('[data-progress]').style.width="100%";
    var g=answers.gender||"unisex",v=answers.vibe||"fresh",budget=answers.budget||"any";
    var sel=scoreMatches(answers),list=sel.items,tryFirst=answers.commit==="try";
    var h='';
    h+='<p class="ar-quiz__res-eyebrow">Your scent profile</p>';
    h+='<h2 class="ar-quiz__res-title">'+(VIBE_LABEL[v]||"")+'</h2>';
    h+='<p class="ar-quiz__res-sub">Fragrances that match your scent profile'+(sel.exact?"":" (closest to your budget)")+'. '+(tryFirst?'Since you like to try first, start any of these as a decant — risk-free.':'Not sure on a full bottle? Try any of these as a decant first.')+'</p>';
    var risk='<div class="ar-quiz__risk"><h3>Try before you commit</h3><p>Sample your matches in a 5ml decant, or grab a curated discovery set — then upgrade to the full bottle.</p><div class="ar-quiz__risk-btns">'+
      '<a class="ar-quiz__btn--gold" href="'+(cfg.discoverySets||"#")+'">Shop discovery sets</a>'+
      '<a class="ar-quiz__btn--ghost" href="'+(cfg.decants||"#")+'">Browse decants</a></div></div>';
    if(tryFirst) h+=risk;
    if(list.length){
      h+='<h3 class="ar-quiz__res-eyebrow" style="font-size:13px;margin-bottom:16px">Fragrances that match your scent profile</h3>';
      h+='<div class="ar-quiz__grid">';
      list.forEach(function(p){
        var chips=(p.accords||[]).slice(0,3).map(function(a){return '<span class="ar-rescard__chip">'+a+'</span>';}).join("");
        h+='<div class="ar-rescard">'+
          (p.img?'<img class="ar-rescard__img" loading="lazy" src="'+p.img+'" alt="'+(p.title||"")+'">':'')+
          (chips?'<div class="ar-rescard__chips">'+chips+'</div>':'')+
          (p.vendor?'<div class="ar-rescard__brand">'+p.vendor+'</div>':'')+
          '<div class="ar-rescard__title">'+(p.title||"")+'</div>'+
          '<div class="ar-rescard__price"><small>Your price</small>'+money(p.price)+'</div>'+
          '<button class="ar-rescard__add" data-vid="'+p.variantId+'">Add to bag</button>'+
          '<a class="ar-rescard__view" data-viewbag href="/cart" hidden>View bag &rarr;</a>'+
          '<a class="ar-rescard__view" href="/products/'+p.handle+'">View details</a>'+
          '<span data-adderr hidden style="font-size:12px;color:#b91c1c;margin-top:6px">Couldn’t add — try again</span>'+
          '<ul class="ar-rescard__checks">'+
            ((p._reasons&&p._reasons.length)
              ? p._reasons.map(function(rs){return '<li>'+rs+'</li>';}).join("")
              : '<li>Specially selected for '+(GENDER_LABEL[g]||"you")+'</li><li>Matches your '+(VIBE_LABEL[v]||"")+' profile</li>')+
          '</ul></div>';
      });
      h+='</div>';
    }
    if(!tryFirst) h+=risk;
    h+='<div class="ar-quiz__email"><h3>Get your full match list</h3><p>'+(cfg.offerLine||"Enter your email to unlock your full match + a welcome offer.")+'</p>'+
      '<form class="ar-quiz__email-form" data-email-form><input type="email" required placeholder="you@email.com" aria-label="Email"><button class="ar-quiz__btn ar-quiz__btn--gold" type="submit">Send it</button></form>'+
      '<p class="ar-quiz__email-msg" data-email-msg></p></div>';
    h+='<button class="ar-quiz__restart" data-restart>Retake the quiz</button>';
    $('[data-results]').innerHTML=h;
    show("results");
    Array.prototype.forEach.call($('[data-results]').querySelectorAll('.ar-rescard__add'),function(b){
      b.addEventListener("click",function(){addToCart(b,b.getAttribute("data-vid"));});
    });
    var rb=$('[data-restart]'); if(rb)rb.addEventListener("click",function(){show("intro");});
    var form=$('[data-email-form]');
    if(form) form.addEventListener("submit",function(e){
      e.preventDefault(); var email=form.querySelector("input").value.trim(),msg=$('[data-email-msg]'); if(!email)return;
      if(cfg.captureUrl){ msg.textContent="Saving your match…";
        fetch(cfg.captureUrl,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:email,gender:g,vibe:v,occasion:answers.occasion,season:answers.season,strength:answers.strength,notesLove:answers.notesLove,notesHate:answers.notesHate,budget:budget,commit:answers.commit,topMatch:(list[0]&&list[0].handle)||null})})
          .then(function(r){return r.json();})
          .then(function(d){msg.textContent=(d&&d.ok)?"You're in — your full match is on its way.":"Hmm, that didn't go through — please try again.";if(d&&d.ok)form.reset();})
          .catch(function(){msg.textContent="Thanks! We'll be in touch.";});
      } else { msg.textContent="Thanks! We'll be in touch."; form.reset(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
